const resultPageHandle = 'microbiome-workflow-generator-results'
const resultCategory = 'microbiome'

function wufooFormDisplay(){
	$('#global-modal-center-title').text('')
	let modalHTML = ` <div id="wufoo-p11hnppz1hz4adc"> Fill out my <a href="https://zymoresearch.wufoo.com/forms/p11hnppz1hz4adc">online form</a>. </div>`;
	$('#global-modal-center-content').html(modalHTML);
	var p11hnppz1hz4adc; (function(d, t) { var s = d.createElement(t), options = { 'userName':'zymoresearch', 'formHash':'p11hnppz1hz4adc', 'autoResize':true, 'height':'645', 'async':true, 'host':'wufoo.com', 'header':'show', 'ssl':true }; s.src = ('https:' == d.location.protocol ?'https://':'http://') + 'secure.wufoo.com/scripts/embed/form.js'; s.onload = s.onreadystatechange = function() { var rs = this.readyState; if (rs) if (rs != 'complete') if (rs != 'loaded') return; try { p11hnppz1hz4adc = new WufooForm(); p11hnppz1hz4adc.initialize(options); p11hnppz1hz4adc.display(); } catch (e) { } }; var scr = d.getElementsByTagName(t)[0], par = scr.parentNode; par.insertBefore(s, scr); })(document, 'script'); 
	$("#global-modal-center-btn").click();
}

$(document).ready(function () {
	if(document.location.origin == 'https://www.zymoresearch.com'){
        if(document.location.pathname.indexOf('microbiome-workflow-generator-results') >= 0){
            let endPromoDate = new Date("2025-01-31");
            let currentPromoDate = new Date();
            if(endPromoDate > currentPromoDate){
                document.getElementById('header_cart').href = '/discount/BUNDLEDEAL24?redirect=/cart';
                document.getElementById('workflow_cart').href = '/discount/BUNDLEDEAL24?redirect=/cart';
            }
        }
	}
	document.getElementById('workflow-share').innerHTML +=	`
	<button onclick="wufooFormDisplay()" type="button" class="wf-header-button"><span class="header-icon"><i class="fa fa-envelope" aria-hidden="true"></i> Contact Us </span></button>
	`;
});

//input workflow object (manages input)
var inputWFObj = {
	"Sample": {
		"stepName": "Sample",
		"htmlText": "Sample Type",
		"sessionName": "sampleTypeMicrobiome", //make sure it's unique between all workflow generators
		"value" : "", //will change depending on what's selected
		"stepType": "dependent", //dependent: show disabled
		"isAnchor": true, //use remove conflicts
		"isProduct": true
	},
	"Extraction": {
		"stepName": "Extraction",
		"htmlText": "Extraction",
		"sessionName": "extractionMicrobiome",
		"value" : "", //will change depending on what's selected
		"stepType": "dependent", //dependent: show disabled
		"isAnchor": false,
		"isProduct": true
	},
	"Analysis": {
		"stepName": "Analysis",
		"htmlText": "Application",
		"sessionName": "applicationMicrobiome",
		"value" : "", //will change depending on what's selected
		"stepType": "dependent", //dependent: show disabled
		"isAnchor": false,
		"isProduct": true
	}
}

const resultCategories = ['Collection Device','Extraction Kit','Application Kit','Controls']

const mappedProducts = {
}

const autoInput = {
	"Sample":{
        "Host-Derived": ["Buccal@Host-Derived", "Buffy Coat@Host-Derived", "Colorectal@Host-Derived", "Lavage@Host-Derived", "Plasma@Host-Derived", "Saliva@Host-Derived", "Serum@Host-Derived", "Stool@Host-Derived", "Urine@Host-Derived", "Vaginal@Host-Derived", "Whole Blood@Host-Derived"],
        "Environmental": ["Plant Tissue@Environmental", "Surfaces@Environmental", "Wastewater (Filter)@Environmental", "Wastewater (Raw)@Environmental", "Water (Filter)@Environmental", "Water (Raw)@Environmental"]
    },
    "Extraction":{
        "Low Throughput": ["DNA@Low Throughput", "DNA/RNA@Low-Throughput", "RNA@Low Throughput"],
        "Mid Throughput": ["DNA@Mid Throughput", "DNA/RNA@Mid-Throughput", "RNA@Mid Throughput"],
        "High Throughput": ["DNA@High Throughput", "DNA/RNA@High-Throughput", "RNA@High Throughput"]
    },
    "Analysis":{
        "Short Read Sequencing": ["16S Amplicon Sequencing@Short Read Sequencing", "ITS Amplicon Sequencing@Short Read Sequencing", "Metatranscriptomics@Short Read Sequencing", "Shotgun Metagenomics@Short Read Sequencing"],
        "Long Read Sequencing": ["16S Amplicon Sequencing@Long Read Sequencing", "ITS Amplicon Sequencing@Long Read Sequencing", "Metatranscriptomics@Long Read Sequencing", "Shotgun Metagenomics@Long Read Sequencing"],
        "Quantitative PCR": ["Quantitative PCR"]
    }
}

const bulkProducts = 	["dna-rna-shield","dna-rna-shield-blood-collection-tube","dna-rna-shield-collection-tube-w-swab",
						"dna-rna-shield-collection-tube-w-swab-dx","dna-rna-shield-fecal-collection-kit","dna-rna-shield-fecal-collection-tube",
						"dna-rna-shield-fecal-collection-tube-dx","dna-rna-shield-lysis-and-collection-tubes","dna-rna-shield-safecollect-saliva-collection-kit",
						"dna-rna-shield-safecollect-swab-collection-kit","dna-rna-shield-saliva-collection-kit","dna-rna-shield-saliva-sputum-collection-kit-dx",
						"dnase-i-set","proteinase-k-w-storage-buffer-set","rnase-a","sterile-collection-swab","urine-conditioning-buffer",
						"zr-96-bashingbead-lysis-rack-barcoded","zymolyase"]

const resultData = { 
	"custom":{
		'Illumina-DNA-Prep-Kit':{
			"title": "Illumina DNA Prep Kit",
			"description": `Illumina DNA Prep, previously known as Nextera DNA Flex, offers a fast, robust, and flexible workflow for preparing normalized, sequencing-ready libraries from a wide range of DNA input types and amounts facilitating an array of applications, from human whole-genome sequencing to sequencing amplicons, plasmids, and microbial species.`,
			"image-url": "https://files.zymoresearch.com/images/illumina-nextera-dna-flex-library-prep-kit.webp",
			"location-parent": "Application Kit",
			"location":"Application Kit Header",
			"location-relative":"afterend",
			"cta": "View Product",
			"url": "https://emea.illumina.com/products/by-type/sequencing-kits/library-prep-kits/illumina-dna-prep.html",
			"cta-function": "window.open('https://emea.illumina.com/products/by-type/sequencing-kits/library-prep-kits/illumina-dna-prep.html', '_blank').focus();"
		}, 
		'Illumina-DNA-Prep-Kit-alt':{
			"title": "Illumina DNA Prep Kit",
			"description": `The Microlab Prep is a benchtop liquid handling platform ideal for sample prep, PCR prep, library prep, or small to mid-scale nucleic acid extraction workflows. <a href="/pages/microbiome-analysis-services#promotions-section" target="_blank">Learn More</a>`,
			"image-url": "https://files.zymoresearch.com/images/workflow_instruments/ml_prep.webp",
			"location-parent": "Application Kit",
			"location":"Application Kit",
			"location-relative":"beforeend",
			"cta": "View Product",
			"url": "/pages/microbiome-analysis-services#promotions-section",
			"cta-function": "window.open('/pages/yeast', '_blank').focus();"
		}, 
	}
}

const customSize = {
	"D6421-PS1": "96 rxns, Primer Set 1",
	"D6421-PS2": "96 rxns, Primer Set 2",
	"D6421-PS3": "96 rxns, Primer Set 3",
	"D6421-PS4": "96 rxns, Primer Set 4",
	"D6421-PS5": "96 rxns, Primer Set 5",
	"D6421-PS6": "96 rxns, Primer Set 6",
	"D6421-PS7": "96 rxns, Primer Set 7",
	"D6421-PS8": "96 rxns, Primer Set 8",
	"D6430-PS1": "96 rxns, Primer Set 1",
	"D6430-PS2": "96 rxns, Primer Set 2",
	"D6430-PS3": "96 rxns, Primer Set 3",
	"D6430-PS4": "96 rxns, Primer Set 4",
}

//input workflow object (manages output)
const autoOutput = {
	"Stool@Host-Derived?DNA@Low Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA@Low Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA@Low Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA@Low Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA@Low Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA@Low Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA@Low Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA@Mid Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA@Mid Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA@Mid Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA@Mid Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA@Mid Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA@Mid Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA@Mid Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA@High Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA@High Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA@High Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA@High Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA@High Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA@High Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA@High Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?RNA@Low Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?RNA@Low Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?RNA@Mid Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?RNA@Mid Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?RNA@High Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?RNA@High Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA/RNA@Low-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA/RNA@Mid-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA/RNA@High-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA/RNA@High-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Stool@Host-Derived?DNA/RNA@High-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-fecal-collection-tube",
		"Collection Device Numbers":"R1137",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Saliva@Host-Derived?DNA@Low Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA@Low Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA@Low Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA@Low Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA@Low Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA@Low Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA@Low Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA@Mid Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA@Mid Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA@Mid Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA@Mid Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA@Mid Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA@Mid Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA@Mid Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA@High Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA@High Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA@High Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA@High Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA@High Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA@High Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA@High Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?RNA@Low Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?RNA@Low Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?RNA@Mid Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?RNA@Mid Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?RNA@High Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?RNA@High Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA/RNA@Low-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA/RNA@Mid-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA/RNA@High-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA/RNA@High-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Saliva@Host-Derived?DNA/RNA@High-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Device Numbers":"R1211,R1211-10,R1211-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA@Low Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA@Low Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA@Low Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA@Low Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA@Low Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA@Low Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA@Low Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA@Mid Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA@Mid Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA@Mid Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA@Mid Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA@Mid Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA@Mid Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA@Mid Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA@High Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA@High Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA@High Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA@High Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA@High Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA@High Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA@High Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?RNA@Low Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?RNA@Low Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?RNA@Mid Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?RNA@Mid Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?RNA@High Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?RNA@High Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA/RNA@Low-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA/RNA@Mid-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA/RNA@High-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA/RNA@High-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Buccal@Host-Derived?DNA/RNA@High-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-oral-microbiome-standard",
		"Controls Numbers":"D6332",
	},
	"Colorectal@Host-Derived?DNA@Low Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA@Low Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA@Low Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA@Low Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA@Low Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA@Low Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA@Low Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA@Mid Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA@Mid Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA@Mid Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA@Mid Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA@Mid Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA@Mid Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA@Mid Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA@High Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA@High Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA@High Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA@High Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA@High Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA@High Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA@High Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?RNA@Low Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?RNA@Low Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?RNA@Mid Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?RNA@Mid Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?RNA@High Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?RNA@High Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA/RNA@Low-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA/RNA@Mid-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA/RNA@High-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA/RNA@High-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Colorectal@Host-Derived?DNA/RNA@High-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-gut-microbiome-standard",
		"Controls Numbers":"D6331",
	},
	"Vaginal@Host-Derived?DNA@Low Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA@Low Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA@Low Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA@Low Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA@Low Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA@Low Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA@Low Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA@Mid Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA@Mid Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA@Mid Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA@Mid Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA@Mid Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA@Mid Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA@Mid Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA@High Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA@High Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA@High Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA@High Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA@High Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA@High Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA@High Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?RNA@Low Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?RNA@Low Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?RNA@Mid Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?RNA@Mid Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?RNA@High Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?RNA@High Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA/RNA@Low-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA/RNA@Mid-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA/RNA@High-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA/RNA@High-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Vaginal@Host-Derived?DNA/RNA@High-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA@Low Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA@Low Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA@Low Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA@Low Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA@Low Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA@Low Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA@Low Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA@Mid Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA@Mid Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA@Mid Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA@Mid Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA@Mid Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA@Mid Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA@Mid Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA@High Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA@High Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA@High Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA@High Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA@High Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA@High Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA@High Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?RNA@Low Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?RNA@Low Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?RNA@Mid Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?RNA@Mid Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?RNA@High Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?RNA@High Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA/RNA@Low-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA/RNA@Mid-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA/RNA@High-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA/RNA@High-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Host-Derived?DNA/RNA@High-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-blood-collection-tube",
		"Collection Device Numbers":"R1150",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA@Low Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA@Low Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA@Low Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA@Low Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA@Low Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA@Low Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA@Low Throughput?Quantitative PCR": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA@Mid Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA@Mid Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA@Mid Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA@Mid Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA@Mid Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA@Mid Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA@Mid Throughput?Quantitative PCR": {
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA@High Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA@High Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA@High Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA@High Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA@High Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA@High Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA@High Throughput?Quantitative PCR": {
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?RNA@Low Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?RNA@Low Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?RNA@Mid Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?RNA@Mid Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?RNA@High Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?RNA@High Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA/RNA@Low-Throughput?Quantitative PCR": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA/RNA@Mid-Throughput?Quantitative PCR": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA/RNA@High-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA/RNA@High-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Host-Derived?DNA/RNA@High-Throughput?Quantitative PCR": {
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA@Low Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA@Low Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA@Low Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA@Low Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA@Low Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA@Low Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA@Low Throughput?Quantitative PCR": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA@Mid Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA@Mid Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA@Mid Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA@Mid Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA@Mid Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA@Mid Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA@Mid Throughput?Quantitative PCR": {
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA@High Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA@High Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA@High Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA@High Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA@High Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA@High Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA@High Throughput?Quantitative PCR": {
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?RNA@Low Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?RNA@Low Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?RNA@Mid Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?RNA@Mid Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?RNA@High Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?RNA@High Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA/RNA@Low-Throughput?Quantitative PCR": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA/RNA@Mid-Throughput?Quantitative PCR": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA/RNA@High-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA/RNA@High-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Host-Derived?DNA/RNA@High-Throughput?Quantitative PCR": {
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA@Low Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA@Low Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA@Low Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA@Low Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA@Low Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA@Low Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA@Low Throughput?Quantitative PCR": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA@Mid Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA@Mid Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA@Mid Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA@Mid Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA@Mid Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA@Mid Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA@Mid Throughput?Quantitative PCR": {
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA@High Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA@High Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA@High Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA@High Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA@High Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA@High Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA@High Throughput?Quantitative PCR": {
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?RNA@Low Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?RNA@Low Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?RNA@Mid Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?RNA@Mid Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?RNA@High Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?RNA@High Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA/RNA@Low-Throughput?Quantitative PCR": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA/RNA@Mid-Throughput?Quantitative PCR": {
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA/RNA@High-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA/RNA@High-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Host-Derived?DNA/RNA@High-Throughput?Quantitative PCR": {
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA@Low Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA@Low Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA@Low Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA@Low Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA@Low Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA@Low Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA@Low Throughput?Quantitative PCR": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA@Mid Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA@Mid Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA@Mid Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA@Mid Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA@Mid Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA@Mid Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA@Mid Throughput?Quantitative PCR": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA@High Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA@High Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA@High Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA@High Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA@High Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA@High Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA@High Throughput?Quantitative PCR": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?RNA@Low Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?RNA@Low Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?RNA@Mid Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?RNA@Mid Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?RNA@High Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?RNA@High Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA/RNA@Low-Throughput?Quantitative PCR": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA/RNA@Mid-Throughput?Quantitative PCR": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA/RNA@High-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA/RNA@High-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Host-Derived?DNA/RNA@High-Throughput?Quantitative PCR": {
		"Collection Device Handle":"urine-collection-kit",
		"Collection Device Numbers":"D3062",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA@Low Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA@Low Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA@Low Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA@Low Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA@Low Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA@Low Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA@Low Throughput?Quantitative PCR": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA@Mid Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA@Mid Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA@Mid Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA@Mid Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA@Mid Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA@Mid Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA@Mid Throughput?Quantitative PCR": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA@High Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA@High Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA@High Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA@High Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA@High Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA@High Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA@High Throughput?Quantitative PCR": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?RNA@Low Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?RNA@Low Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?RNA@Mid Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?RNA@Mid Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?RNA@High Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?RNA@High Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA/RNA@Low-Throughput?Quantitative PCR": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA/RNA@Mid-Throughput?Quantitative PCR": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA/RNA@High-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA/RNA@High-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lavage@Host-Derived?DNA/RNA@High-Throughput?Quantitative PCR": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA@Low Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA@Low Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA@Low Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA@Low Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA@Low Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA@Low Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA@Low Throughput?Quantitative PCR": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA@Mid Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA@Mid Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA@Mid Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA@Mid Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA@Mid Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA@Mid Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA@Mid Throughput?Quantitative PCR": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA@High Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA@High Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA@High Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA@High Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA@High Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA@High Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA@High Throughput?Quantitative PCR": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?RNA@Low Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?RNA@Low Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?RNA@Mid Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?RNA@Mid Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?RNA@High Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?RNA@High Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA/RNA@Low-Throughput?Quantitative PCR": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA/RNA@Mid-Throughput?Quantitative PCR": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA/RNA@High-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA/RNA@High-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Raw)@Environmental?DNA/RNA@High-Throughput?Quantitative PCR": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA@Low Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA@Low Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA@Low Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA@Low Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA@Low Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA@Low Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA@Low Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA@Mid Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA@Mid Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA@Mid Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA@Mid Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA@Mid Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA@Mid Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA@Mid Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA@High Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA@High Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA@High Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA@High Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA@High Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA@High Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA@High Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?RNA@Low Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?RNA@Low Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?RNA@Mid Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?RNA@Mid Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?RNA@High Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?RNA@High Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA/RNA@Low-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA/RNA@Mid-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA/RNA@High-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA/RNA@High-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Wastewater (Filter)@Environmental?DNA/RNA@High-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA@Low Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA@Low Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA@Low Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA@Low Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA@Low Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA@Low Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA@Low Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA@Mid Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA@Mid Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA@Mid Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA@Mid Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA@Mid Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA@Mid Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA@Mid Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA@High Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA@High Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA@High Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA@High Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA@High Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA@High Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA@High Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?RNA@Low Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?RNA@Low Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?RNA@Mid Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?RNA@Mid Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?RNA@High Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?RNA@High Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA/RNA@Low-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA/RNA@Mid-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA/RNA@High-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA/RNA@High-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plant Tissue@Environmental?DNA/RNA@High-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA@Low Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA@Low Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA@Low Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA@Low Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA@Low Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA@Low Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA@Low Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA@Mid Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA@Mid Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA@Mid Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA@Mid Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA@Mid Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA@Mid Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA@Mid Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA@High Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA@High Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA@High Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA@High Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA@High Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA@High Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA@High Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?RNA@Low Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?RNA@Low Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?RNA@Mid Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?RNA@Mid Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?RNA@High Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?RNA@High Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA/RNA@Low-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA/RNA@Mid-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA/RNA@High-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA/RNA@High-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Surfaces@Environmental?DNA/RNA@High-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield-safecollect-swab-collection-kit",
		"Collection Device Numbers":"R1160,R1160-10,R1160-50",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA@Low Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA@Low Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA@Low Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA@Low Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA@Low Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA@Low Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA@Low Throughput?Quantitative PCR": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA@Mid Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA@Mid Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA@Mid Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA@Mid Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA@Mid Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA@Mid Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA@Mid Throughput?Quantitative PCR": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA@High Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA@High Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA@High Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA@High Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA@High Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA@High Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA@High Throughput?Quantitative PCR": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?RNA@Low Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?RNA@Low Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?RNA@Mid Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?RNA@Mid Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?RNA@High Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?RNA@High Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA/RNA@Low-Throughput?Quantitative PCR": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA/RNA@Mid-Throughput?Quantitative PCR": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA/RNA@High-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA/RNA@High-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Raw)@Environmental?DNA/RNA@High-Throughput?Quantitative PCR": {
		"Collection Device Handle":"water-concentrating-buffer",
		"Collection Device Numbers":"R2042-1-8,R2042-1-140",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA@Low Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA@Low Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA@Low Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA@Low Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA@Low Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA@Low Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA@Low Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-microprep-kit",
		"Extraction Kit Numbers":"D4301",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA@Mid Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA@Mid Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA@Mid Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA@Mid Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA@Mid Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA@Mid Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA@Mid Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-dna-kit",
		"Extraction Kit Numbers":"D4303,D4309",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA@High Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA@High Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA@High Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA@High Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA@High Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA@High Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA@High Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-96-magbead-kit",
		"Extraction Kit Numbers":"D4302,D4308",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?RNA@Low Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?RNA@Low Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?RNA@Mid Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?RNA@Mid Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2001",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?RNA@High Throughput?Metatranscriptomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?RNA@High Throughput?Metatranscriptomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-magbead-rna",
		"Extraction Kit Numbers":"R2137,R2138",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA/RNA@Low-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA/RNA@Low-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA/RNA@Low-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA/RNA@Low-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6421-PS1,D6421-PS2,D6421-PS3,D6421-PS4,D6421-PS5,D6421-PS6,D6421-PS7,D6421-PS8,D6430-PS1,D6430-PS2,D6430-PS3,D6430-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA/RNA@Mid-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA/RNA@Mid-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA/RNA@Mid-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA/RNA@Mid-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-dna-rna-miniprep-kit",
		"Extraction Kit Numbers":"R2002",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA/RNA@High-Throughput?Shotgun Metagenomics@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"[Application]":"Illumina-DNA-Prep-Kit",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Short Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1,D6425-PS2,D6425-PS3,D6425-PS4",
		"Application Kit 2 Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"Application Kit 2 Numbers":"R3000,R3003",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA/RNA@High-Throughput?Shotgun Metagenomics@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA/RNA@High-Throughput?16S Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA/RNA@High-Throughput?ITS Amplicon Sequencing@Long Read Sequencing": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Water (Filter)@Environmental?DNA/RNA@High-Throughput?Quantitative PCR": {
		"Collection Device Handle":"dna-rna-shield",
		"Collection Device Numbers":"R1100-50,R1100-250",
		"Extraction Kit Handle":"zymobiomics-magbead-dna-rna",
		"Extraction Kit Numbers":"R2135,R2136",
		"Application Kit Handle":"femto-bacterial-dna-quantification-kit,femto-fungal-dna-quantification-kit",
		"Application Kit Numbers":"E2006,E2007",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
}